import DashboardLayout from '@/layout/dashboard/DashboardLayout.vue';
// GeneralViews
import NotFound from '@/pages/NotFoundPage.vue';

const Tricks = () => import(/* webpackChunkName: "tricks" */ '@/pages/Tricks.vue');
const Brands = () => import(/* webpackChunkName: "marcas" */ '@/pages/Brands.vue');
const SurveyClasses = () => import(/* webpackChunkName: "surveyClasses" */ '@/pages/SurveyClasses.vue');
const Campaign = () => import(/* webpackChunkName: "campanhas" */ '@/pages/Campaign.vue');
const CampaignDetails = () => import(/* webpackChunkName: "campanha-details" */ '@/pages/CampaignDetails.vue');
const Questions = () => import(/* webpackChunkName: "questions" */ '@/pages/Questions.vue');
const Users = () => import(/* webpackChunkName: "usuarios" */ '@/pages/Users.vue');
const ProfileQuestions = () => import(/* webpackChunkName: "profileQuestions" */ '@/pages/ProfileQuestions.vue');
const Login = () => import(/* webpackChunkName: "login" */ '@/pages/Login.vue');
const Config = () => import(/* webpackChunkName: "config" */ '@/pages/Config.vue');
const Validate = () => import(/* webpackChunkName: "validation" */ '@/pages/SocialLoginValidation.vue');
const LoginFailure = () => import('@/pages/LoginFailure.vue');
const Branches = () => import(/* webpackChunkName: "ramos" */ '@/pages/Branches.vue');
const Partners = () => import(/* webpackChunkName: "parceiros" */ '@/pages/Partners.vue');
const Withdrawals = () => import(/* webpackChunkName: "saques" */ '@/pages/Withdrawals.vue');
const Items = () => import(/* webpackChunkName: "items" */ '@/pages/Items.vue');
const BrandTypes = () => import(/* webpackChunkName: "brandTypes" */ '@/pages/BrandTypes.vue');

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/marcas',
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('auth')) {
        next();
      } else {
        next({ name: 'login' });
      }
    },
    children: [
      {
        path: 'marcas',
        name: 'marcas',
        component: Brands,
      },
      {
        path: 'profileQuestions',
        name: 'profileQuestions',
        component: ProfileQuestions,
      },
      {
        path: 'surveyClasses',
        name: 'classes',
        component: SurveyClasses,
      },
      {
        path: 'tricks',
        name: 'tricks',
        component: Tricks,
      },
      {
        path: 'usuarios',
        name: 'usuarios',
        component: Users,
      },
      {
        path: 'saques',
        name: 'saques',
        component: Withdrawals,
      },
      {
        path: 'ramos',
        name: 'ramos',
        component: Branches,
      },
      {
        path: 'parceiros',
        name: 'parceiros',
        component: Partners,
      },
      {
        path: 'config',
        name: 'config',
        component: Config,
      },
      {
        path: 'questions',
        name: 'questions',
        component: Questions,
      },
      // {
      //   path: 'campanhas',
      //   name: 'campanhas',
      //   component: Campaign,
      // },
      {
        path: 'campanhas',
        name: 'campanha-details',
        component: CampaignDetails,
      },
      {
        path: 'productsAndServices',
        name: 'products-and-services',
        component: Items,
      },
      {
        path: 'brandTypes',
        name: 'brand-types',
        component: BrandTypes,
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/success',
    query: {
      token: null,
    },
    name: 'social-login-validation',
    component: Validate,
  },
  {
    path: '/login/failure',
    name: 'login-failure',
    component: LoginFailure,
  },
  { path: '*', component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
